import React from 'react'

import APStartCTASection from "./APStartCTASection/APStartCTASection"
import AdoptionProcessInfoSection from "./AdoptionProcessInfoSection/AdoptionProcessInfoSection"

const AdoptionProcessStart = () => {
  return (
    <div>
      <APStartCTASection />
      <AdoptionProcessInfoSection />
    </div>
  );
}

export default AdoptionProcessStart
